"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dropdown = exports.Wrap = exports.Container = exports.AccordionSection = void 0;
const tslib_1 = require("tslib");
const styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
const theme_1 = require("@monorepo/theme");
exports.AccordionSection = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 1rem 0;
`;
exports.Container = styled_components_1.default.div `
  width: 100%;
  max-width: 848px;

  h1 {
    margin-bottom: 40px;
    font-size: 2rem;
    font-weight: 400;
  }
`;
exports.Wrap = styled_components_1.default.div `
  background: ${theme_1.colors.white};
  color: ${theme_1.colors.black};
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 30px 0;
  text-align: left;
  cursor: pointer;
  border-top: 1px solid #dddfe2;
  border-bottom: 1px solid #dddfe2;

  h2 {
    font-size: 22px;
    font-weight: 700;
  }

  span {
    font-weight: 700;
    margin: 0 0.5rem;
  }
`;
exports.Dropdown = styled_components_1.default.div `
  padding: 10px;
  background-color: ${theme_1.colors.white};
`;
